import React from 'react';

import { TOOL_IDS } from '@adsk/alloy-provider';
import { StampIcon } from '@adsk/alloy-react-icon';
import { TabTitle } from '@adsk/exo-skeleton-react';

import { queryEntities, getEntitiesByIds } from './api/entities';
import {
  SubmittalsDataView,
  EntityBlock,
  EntityMenuItem,
  FiltersPanel,
  SubmittalsActivityCard,
  SearchBox,
} from './components';
import Provider from './components/Provider';
import {
  RemoveConfirmationModalTitle,
  RemoveConfirmationModalContent,
} from './components/RemoveConfirmationModal';
import { useTranslation } from './i18n';
import { SubmittalsItem } from './types';
import ReferencePickerPlugin from '../../types/ReferencePickerPlugin';

const plugin: ReferencePickerPlugin<SubmittalsItem> = {
  metadata: {
    domain: 'autodesk-construction-submittals',
    type: 'submittalitem',
  },
  renderIcon: StampIcon.renderIcon,
  showSearchBox: true,
  toolId: TOOL_IDS.SUBMITTALS,
  is3LOSupported: true,

  PluralText: ({ lowerCase }) => {
    const { t } = useTranslation();
    const result = t('SUBMITTALS');
    if (typeof result === 'string' && lowerCase) {
      return result.toLowerCase();
    }
    return result;
  },
  PickerModalTitle: ({ showTabTitle = true }) => {
    const { t } = useTranslation();
    const value = t('ADD_SUBMITTALS_REFERENCE');

    return (
      <>
        {showTabTitle && <TabTitle value={value as string} />}
        {value}
      </>
    );
  },
  AddRelationshipsButtonText: ({ count }) => {
    const { t } = useTranslation();
    return t('ADD_ITEM', { count });
  },
  SelectedCount: ({ count }) => {
    const { t } = useTranslation();
    return t('SUBMITTALS_SELECTED', { count });
  },
  queryEntities,
  getEntitiesByIds: ({ ids, projectId }) => getEntitiesByIds(projectId, ids),

  // components
  CustomDataView: SubmittalsDataView,
  EntityBlock,
  EntityMenuItem,
  FiltersPanel,
  ActivityCard: SubmittalsActivityCard,
  CustomPickerSearchBox: SearchBox,

  CustomRemoveEntityModalTitle: RemoveConfirmationModalTitle,
  CustomRemoveEntityModalContent: RemoveConfirmationModalContent,

  Provider,
};

export default plugin;
